import React, { useState, useEffect } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import apiClient from "../../utils/api";
import { mockExitLocations } from '../../components/Data/MockData';
import { toast } from 'react-toastify';

function ExitLocationsEdit() {
    const navigate = useNavigate();
    const { id } = useParams();    
    const [formData, setFormData] = useState({
        name: '',
        parking_space: '',
        is_active: "1",
        logo: null,
        phone_number: ''
    });
    const [previewLogo, setPreviewLogo] = useState(null);
    const [currentLogo, setCurrentLogo] = useState(null);

    useEffect(() => {
        fetchLocation();
    }, [id]);

    const fetchLocation = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/exit-locations/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData({
                ...response.data.data,
                is_active: response.data.data.is_active ? "1" : "0"
            });
            if (response.data.data.logo) {
                setCurrentLogo(response.data.data.logo);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading location');
            navigate('/accounts/exit-locations-list');
        }
    };

    const handleInputChange = (e) => {
        const { name, type, value, checked, files } = e.target;
        
        if (type === 'file') {
            setFormData({
                ...formData,
                [name]: files[0]
            });
            // Preview the selected logo
            if (files[0]) {
                setPreviewLogo(URL.createObjectURL(files[0]));
            } else {
                setPreviewLogo(null);
            }
        } else {
            setFormData({
                ...formData,
                [name]: type === 'checkbox' ? (checked ? "1" : "0") : value
            });
        }
    };    
    
    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('parking_space', formData.parking_space);
        data.append('is_active', formData.is_active);
        if (formData.phone_number) {
            data.append('phone_number', formData.phone_number);
        }
        if (formData.logo instanceof File) {
            data.append('logo', formData.logo);
        }
        data.append('_method', 'PUT');

        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post(`accounts/exit-locations/${id}`, data, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            toast.success('Valet Location updated successfully');
            navigate(process.env.PUBLIC_URL + '/accounts/exit-locations-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error updating location');
        }
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Edit Valet Location" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <Card>
                        <Card.Body>
                            <Form onSubmit={onSubmit}>
                                <div className="row g-3">                                    
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Location Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phone_number"
                                                value={formData.phone_number || ''}
                                                onChange={handleInputChange}
                                                placeholder="Enter phone number"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Parking Space</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="parking_space"
                                                value={formData.parking_space}
                                                onChange={handleInputChange}
                                                min="0"
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Logo</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="logo"
                                                onChange={handleInputChange}
                                                accept="image/*"
                                            />
                                            {previewLogo ? (
                                                <div className="mt-2">
                                                    <img 
                                                        src={previewLogo} 
                                                        alt="Logo Preview" 
                                                        style={{ maxWidth: '200px', maxHeight: '100px' }} 
                                                    />
                                                </div>
                                            ) : currentLogo && (
                                                <div className="mt-2">
                                                    <img 
                                                        src={`${process.env.REACT_APP_STORAGE_URL}${currentLogo}`} 
                                                        alt="Current Logo" 
                                                        style={{ maxWidth: '200px', maxHeight: '100px' }} 
                                                    />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <ActiveStatus
                                                onStatusChange={handleInputChange}
                                                checked={formData.is_active}
                                                name="is_active"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Button type="submit" variant="primary">
                                            Update Location
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default ExitLocationsEdit;